import ComponentLayout from "../../../../src/layouts/component-layout";
import { TextSizes, TextTags, TextVariants, TextWeights, defaultTextVariant, defaultTextTag, defaultTextSize } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  TextSizes,
  TextTags,
  TextVariants,
  TextWeights,
  defaultTextVariant,
  defaultTextTag,
  defaultTextSize,
  Container,
  PropTableValues,
  React
};